import type { Daylist, DaylistCenterSupplier } from 'api-client'

function toDateKey(date: Date | null | undefined): string {
  if (!date) return ''
  const d = new Date(date)
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
}

/**
 * From daylist_center_supplier get the list of days to display (past + today + future).
 * - Unique by (real date, rectype) because multiple centers/suppliers can have different dateno for the same date.
 * - Sort by datevalue then assign dateno/colname sequentially (col1, col2, ...) to match rows and columns.
 */
export function getDisplayDaylistFromCenterSupplier(
  daylistCenterSupplier: DaylistCenterSupplier[] | null | undefined
): Daylist[] {
  if (!daylistCenterSupplier || daylistCenterSupplier.length === 0) return []

  const rectypeOrder: Record<string, number> = { rec: 0, today: 1, expected: 2 }

  const byDateAndRectype = daylistCenterSupplier
    .filter((d) => d.datevalue != null && (d.rectype ?? '') !== '')
    .reduce((map, d) => {
      const dateKey = toDateKey(d.datevalue)
      const r = d.rectype ?? ''
      const key = `${dateKey}_${r}`
      if (!map.has(key)) {
        map.set(key, d)
      }
      return map
    }, new Map<string, DaylistCenterSupplier>())

  const sorted = Array.from(byDateAndRectype.values()).sort((a, b) => {
    const tA = a.datevalue ? new Date(a.datevalue).getTime() : 0
    const tB = b.datevalue ? new Date(b.datevalue).getTime() : 0
    if (tA !== tB) return tA - tB
    return (rectypeOrder[a.rectype ?? ''] ?? 99) - (rectypeOrder[b.rectype ?? ''] ?? 99)
  })

  return sorted.map((d, index): Daylist => {
    const dateno = index + 1
    const colname = `col${dateno}`
    return {
      dateno,
      rectype: d.rectype,
      weekNo: null,
      colname,
      datevalue: d.datevalue,
      rectypeName: null,
      orderDate: d.orderDate,
      newitemStartFlg: null,
      renewalNumber: null,
      isOrderConfirmed: d.isOrderConfirmed,
      isOrderToday: d.isOrderToday,
      isUpdatedArrivalTmp: d.isUpdatedArrivalTmp,
    }
  })
}
